import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { PageDynamicSubheaderComponent } from './page-dynamic-subheader.component';
import { TipModule } from '../tip/tip.module';


@NgModule({
  declarations: [
    PageDynamicSubheaderComponent
  ],
  exports: [
    PageDynamicSubheaderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    TipModule
  ]
})
export class PageDynamicSubheaderModule { }
